import React from "react";

import { AutoFormFieldProps } from "@autoform/react";

export const HiddenField: React.FC<AutoFormFieldProps> = () => null;

export default HiddenField;
